import { ProductTableQuickViewButton } from './ProductTableQuickViewButton';

export default ProductTableQuickViewButton;